import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "area-control-dialog" };
const _hoisted_2 = { class: "content-wrapper" };
import VerticalDividedDialog from '@/templates/VerticalDividedDialog.vue';
import MapWrapper from '@/views/DeliveryChargeAreaControl/MapWrapper.vue';
import RegisteredAreaWrapper from '@/views/DeliveryChargeAreaControl/RegisteredAreaWrapper.vue';
import { initAutoLc } from '@/locales/ko/views/delivery_charge_dialog';
import { computed, onMounted, onUnmounted, } from 'vue';
import { deliveryChargeActionType } from '@/vuex-store/delivery-charge-dialog/actions';
import vuexStore from '@/vuex-store';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        // 구역선택 다이얼로그
        const lc = initAutoLc('dialog.');
        const isOpen = computed(() => vuexStore.getters['deliveryChargeDialog/getterIsAreaDialogOpen']);
        const subscribeHub = computed(() => vuexStore.getters['hubSelector/getterSubscribeHub']);
        /**
         * 선택영역 저장 및 닫기
         * @param item
         */
        const onSelectArea = (areaItem) => {
            vuexStore.dispatch(deliveryChargeActionType.selectedArea, areaItem);
            vuexStore.dispatch(deliveryChargeActionType.areaDialogClose);
        };
        /**
         * 성공 이벤트
         */
        const onApply = () => {
            vuexStore.dispatch(deliveryChargeActionType.areaDialogClose);
        };
        /**
         * 닫기 이벤트
         */
        const onCancel = () => {
            vuexStore.dispatch(deliveryChargeActionType.areaDialogClose);
        };
        onMounted(() => {
            const hub = vuexStore.state.deliveryChargeDialog.storeDetail?.hub;
            vuexStore.dispatch('hubSelector/setTmpSubscribeHubInfo', [
                {
                    type: 'HUB',
                    id: hub.id,
                    hubId: hub.id,
                    hubName: hub.name,
                },
            ]);
        });
        onUnmounted(() => {
            vuexStore.dispatch('hubSelector/deleteTmpSubscribeHubInfo');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(VerticalDividedDialog, {
                "is-open": isOpen.value,
                "on-apply": onApply,
                "on-cancel": onCancel,
                "has-left-title": false,
                "has-footer": false,
                "is-content-box-padding": false,
                "dialog-css-class": "width-md ratio-full",
                height: 750
            }, {
                title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(lc)('title')) + " / " + _toDisplayString(subscribeHub.value.hubName), 1 /* TEXT */)
                ]),
                leftContent: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(MapWrapper, { class: "map" }),
                            _createCommentVNode(" 등록된 구역 목록 "),
                            _createVNode(RegisteredAreaWrapper, {
                                class: "controller",
                                "is-select-mode": "",
                                "on-select-area": onSelectArea
                            })
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["is-open"]));
        };
    }
});
